import { render, staticRenderFns } from "./incomeAnalysis.vue?vue&type=template&id=61b45125&"
import script from "./incomeAnalysis.vue?vue&type=script&lang=js&"
export * from "./incomeAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports